import * as React from "react";

import { Close as CloseIcon, Edit as EditIcon } from "@mui/icons-material";
import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Stack, styled, Typography } from "@mui/material";

import { UpdateTemplateDTO, UpdateTemplateForm } from "src/domain/core/templates";

interface UpdateTemplateDialogProps {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  template: Template;
  templates: Template[];
  nodes: Nodes;
  blueprints: WorkflowBlueprintDesc[];
  disks?: Disk[];
  disksError?: Error;
  templateGroups?: WorkflowTemplateGroup[];
  groups?: Group[];
  updateTemplate: (template: UpdateTemplateDTO) => any;
}

const TitleText = styled(Typography)(() => ({
  fontSize: "20px",
  textAlign: "left",
}));

const SubText = styled(Typography)(() => ({
  fontSize: "14px",
  textAlign: "left",
}));

export const UpdateTemplateDialog: React.FC<UpdateTemplateDialogProps> = ({
  modalOpen,
  setModalOpen,
  template,
  templates,
  nodes,
  blueprints,
  disks,
  disksError,
  templateGroups,
  groups,
  updateTemplate,
}) => {
  return (
    <Dialog
      open={modalOpen}
      onClose={(event, reason) => {
        if (reason && reason == "backdropClick") return;
        setModalOpen(false);
      }}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle
        sx={{
          paddingLeft: "22px",
          color: "#ffffff",
          backgroundColor: (theme) => theme.palette.primary.main,
        }}
      >
        <Grid container alignItems="center">
          <Grid item container justifyContent="flex-start" xs={11}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "50px",
                paddingRight: "7px",
              }}
            >
              <EditIcon sx={{ fontSize: 40 }} />
            </Box>
            <Stack spacing={0}>
              <TitleText>Edit {template?.templateName}</TitleText>
              <SubText>Blueprint: {template?.blueprintName}</SubText>
            </Stack>
          </Grid>
          <Grid item container justifyContent="flex-end" xs={1}>
            <IconButton aria-label="close" onClick={() => setModalOpen(false)}>
              <CloseIcon sx={{ color: "#ffffff" }} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <UpdateTemplateForm
          nodeData={{
            head_node_instance_types: nodes?.cpus?.head,
            compute_node_instance_types: nodes?.cpus?.compute,
            gpu_head_node_instance_types: nodes?.gpus?.head,
            gpu_compute_node_instance_types: nodes?.gpus?.compute,
          }}
          blueprints={blueprints}
          template={template}
          templates={templates}
          close={() => setModalOpen(false)}
          disks={disks}
          disksError={disksError}
          templateGroups={templateGroups}
          groups={groups}
          updateTemplate={updateTemplate}
        />
      </DialogContent>
    </Dialog>
  );
};
